
import { GradeLevel, Resource, JournalEntry } from './types';

export const TEXT = {
  navHome: "Нүүр",
  navLibrary: "Номын сан",
  navVolunteer: "Багшлах / Тусламж авах",
  navProfile: "Хувийн мэдээлэл",
  heroTitle: "Anir",
  heroTag1: "Баталгаажсан ангиуд",
  heroTag2: "Үе тэнгийн зөвлөгөө",
  heroTag3: "Нээлттэй эх сурвалж",
  heroSubtitle: "Суралцах ирээдүй",
  missionTitle: "Монгол сурагчдад зориулсан нээлттэй боловсролын гүүр.",
  missionDesc: "Мэдлэг эрэлхийлэхэд нэг ч сурагч хоцрохгүй байхын тулд үе тэнгийн зөвлөгчид болон бэлтгэсэн эх сурвалжуудыг холбож байна.",
  impactTitle: "Нөлөөллийн тайлан 2024",
  impactSub: "Талын даяарх бидний өсөлтийг хянах.",
  libraryTitle: "Эрдэм шинжилгээний номын сан",
  librarySub: "Бүх түвшний сурагчдад зориулсан баталгаажсан Монгол сургалтын хөтөлбөрийн материалууд.",
  searchPlaceholder: "Хичээл, сэдэв эсвэл түлхүүр үгээр хайх...",
  volunteerTitle: "Мэдлэгээ хуваалц.",
  volunteerSub: "Бусдад зааж, өөрөө суралц.",
  joinButton: "Одоо нэгдэх",
  profileTitle: "Хувийн мэдээлэл",
  profileSub: "Сурагчийн үнэмлэх",
};

export const MOCK_RESOURCES: Resource[] = [
  { 
    id: '1', 
    title: 'Гурван гишүүнтийг үржигдэхүүн болгон задлах', 
    subject: 'Algebra 1', 
    level: GradeLevel.GRADE_9, 
    type: 'Text', 
    duration: '20м', 
    progress: 100, 
    subTopic: 'Олон гишүүнт',
    content: 'Олон гишүүнтийг үржигдэхүүн болгон задлах нь алгебрын үндсэн үйлдлүүдийн нэг юм. Энэ нь илэрхийллийг хялбарчлах, тэгшитгэл бодоход чухал үүрэгтэй...',
    quiz: [
      { id: 'q1', question: 'x^2 + 5x + 6 илэрхийллийг үржигдэхүүн болгон задалбал аль нь зөв бэ?', options: ['(x+2)(x+3)', '(x+1)(x+6)', '(x-2)(x-3)', '(x+5)(x+1)'], correctAnswer: 0 },
      { id: 'q2', question: 'x^2 - 9 илэрхийллийг үржигдэхүүн болгон задалбал аль нь зөв бэ?', options: ['(x-3)^2', '(x+3)^2', '(x-3)(x+3)', '(x-9)(x+1)'], correctAnswer: 2 }
    ]
  },
  { 
    id: '2', 
    title: 'Үелэх систем', 
    subject: 'Inorganic Chemistry', 
    level: GradeLevel.GRADE_10, 
    type: 'Quiz', 
    duration: '15м', 
    progress: 80, 
    subTopic: 'Элементүүд',
    quiz: [
      { id: 'q3', question: 'Үелэх системийн 1-р бүлгийн элементүүдийг юу гэж нэрлэдэг вэ?', options: ['Галоген', 'Шүлтийн металл', 'Идэвхгүй хий', 'Газрын шүлтийн металл'], correctAnswer: 1 },
      { id: 'q4', question: 'Хүчилтөрөгчийн атомын дугаар хэд вэ?', options: ['6', '7', '8', '9'], correctAnswer: 2 }
    ]
  },
  { id: '3', title: 'Пифагорын теорем', subject: 'Geometry', level: GradeLevel.GRADE_8, type: 'Image', duration: '10м', progress: 100, subTopic: 'Гурвалжин' },
  { id: '4', title: 'Шекспирийн сонетууд', subject: 'Classical Literature', level: GradeLevel.GRADE_10, type: 'Text', duration: '25м', progress: 10, subTopic: 'Яруу найраг' },
  { id: '5', title: 'Нүүрстөрөгчийн нэгдлүүд', subject: 'Organic Chemistry', level: GradeLevel.GRADE_12, type: 'Quiz', duration: '30м', progress: 0, subTopic: 'Нүүрсустөрөгч' },
  { id: '6', title: 'Эсийн хуваагдал', subject: 'Biology', level: GradeLevel.GRADE_9, type: 'Text', duration: '20м', progress: 0, subTopic: 'Митоз' },
  { id: '7', title: 'Эртний иргэншил', subject: 'World History', level: GradeLevel.GRADE_7, type: 'Text', duration: '40м', progress: 0, subTopic: 'Месопотами' },
  { id: '8', title: 'Дифференциалчлалын үндэс', subject: 'Calculus', level: GradeLevel.GRADE_12, type: 'Text', duration: '35м', progress: 0, subTopic: 'Хязгаар' },
];

export const MOCK_JOURNALS: JournalEntry[] = [
  { 
    id: 'j1', 
    title: 'How technology helps us learn', 
    author: 'Elena R. (Grade 11)', 
    category: 'Community', 
    date: 'May 15, 2024', 
    readTime: '6 min',
    likes: 42,
    content: 'When we use new tools in our classrooms, it opens up so many new ways to understand the world. I love how we can explore big ideas together...',
    comments: [
      { id: 'c1', author: 'Marcus T.', text: 'I love this idea!', timestamp: '2h ago' }
    ]
  },
  { 
    id: 'j2', 
    title: 'My Journey through Math', 
    author: 'Julian M. (Grade 12)', 
    category: 'Math Tips', 
    date: 'May 10, 2024', 
    readTime: '4 min',
    likes: 28,
    content: 'Math used to be scary, but once I started looking at it like a puzzle, everything changed. Here are the tricks that helped me...',
    comments: []
  },
];

export const DAILY_WORDS = [
  { 
    traditional: "ᠪᠢᠯᠢᠭ", 
    cyrillic: "Билиг", 
    meaning: "Оюун ухаан, танин мэдэхүйн чадвар.", 
    pronunciation: "Bi-lig", 
    sentence: "Эрдэм мэдлэг бол ертөнцийг харах билиг билээ." 
  },
  { 
    traditional: "ᠡᠷᠳᠡᠮ", 
    cyrillic: "Эрдэм", 
    meaning: "Сурч мэдсэн зүйл, боловсрол, мэдлэг.", 
    pronunciation: "Er-dem", 
    sentence: "Эрдэм бол хэзээ ч дуусашгүй баялаг юм." 
  },
  { 
    traditional: "ᠰᠤᠷᠭᠠᠭᠤᠯ", 
    cyrillic: "Сургаал", 
    meaning: "Сургаж хэлсэн үг, сургамж, заавар.", 
    pronunciation: "Sur-gaal", 
    sentence: "Ахмадын сургаал алт мэт үнэтэй." 
  },
  { 
    traditional: "ᠨᠥᠬᠥᠷᠯᠡᠯ", 
    cyrillic: "Нөхөрлөл", 
    meaning: "Бие биедээ итгэх, туслах дотно харилцаа.", 
    pronunciation: "Nö-khör-löl", 
    sentence: "Үнэнч нөхөрлөл бэрхшээлийг хамтдаа туулдаг." 
  },
];

export const NAV_ITEMS = [
  { id: 'home', labelKey: 'navHome' },
  { id: 'resources', labelKey: 'navLibrary' },
  { id: 'tutor-apply', labelKey: 'navVolunteer' },
  { id: 'profile', labelKey: 'navProfile' },
];
